module.exports = __webpack_public_path__ + "linkedin_icon-43aecbd04ef122f76aad118347ec9283.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/icons/linkedin_icon.svg
// module id = 354
// module chunks = 0